import { PARKINGABO_BADGE_LENGTH } from 'dg-web-shared/lib/RfidCardValidation.ts';
import { extractScannedUrlPathValue } from './ScannedUrlNormalization.ts';
import { normalizeTicketSearchInput } from './TicketSearchNormalization.ts';

const PARKINGABO_BADGE_PATH = '/b/';
const PRODUCT_QR_PATH = '/qr/';
const PRODUCT_QR_CODE_PATTERN = /^[A-Z2-7]+$/;

export function normalizeScannedSearchInput(value: string): string {
    return normalizeGuestQrSearchInput(
        normalizeBadgeSearchInput(normalizeTicketSearchInput(value)),
    );
}

export function normalizeBadgeSearchInput(value: string): string {
    const pathValue = extractScannedUrlPathValue(value, PARKINGABO_BADGE_PATH);
    if (!pathValue || pathValue.length !== PARKINGABO_BADGE_LENGTH) {
        return value;
    }
    return pathValue;
}

export function normalizeGuestQrSearchInput(value: string): string {
    const pathValue = extractScannedUrlPathValue(value, PRODUCT_QR_PATH);
    if (!pathValue || !PRODUCT_QR_CODE_PATTERN.test(pathValue)) {
        return value;
    }
    return pathValue;
}
